import request from '../../shared/request'

export function getHeroBanners() {
  return request(`/v1/services/hero-banners`, {
    method: 'GET'
  })
}
